import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { translate } from '@haldor/ui';
import * as microsoftTeams from "@microsoft/teams-js";
import { setUser, getMe, getTenant } from 'actions/user';
import { getEducationGroups, getSections } from 'actions/sections';
import { getTypes } from 'actions/status';
import { getMenuItems } from 'actions/menu';
import { markNotificationAsRead } from 'actions/notifications';
import { getSchoolServices } from 'actions/schools';
import sniffer from 'sniffer';
import { getUser, onMsalTokenError } from 'lib/msal';
import schoolHandling from 'helpers/schoolHandling';
import roleHandling from 'helpers/roleHandling';
import { trackNoGroups } from 'helpers/insights';
import NotificationProvider from 'components/Providers/NotificationProvider';
import Footer from 'components/Footer/Footer';
import Error from 'components/Presentation/Error/Error';
import Menu from 'components/Menu';
import Header from 'components/HeaderV2';
import DeviceHeader from 'components/HeaderV2/Device';
import DesktopHeader from 'components/HeaderV2/Desktop';
import InteractionRequired from 'containers/Errors/InteractionRequired';
import RequiredDataError from 'containers/Errors/RequiredDataError';
import { Spinner } from 'UI';
import { Layout, Content, Sider, getActiveLanguage } from '@haldor/ui';
import packageJson from '../../package.json';
import { appInsights } from 'lib/appInsights'; // Import routes

import MenuPage from 'components/Menu/Page';
import MentorGroups from 'containers/Overview/Sections/MentorGroups';
import SchoolSwitch from 'components/SchoolSwitch/SchoolSwitch';
import AbsenceOverview from 'containers/Absence/AbsenceOverview';
import AttendanceOverview from 'containers/Attendance/AttendanceOverview';
import ConversationPage from 'containers/Conversation/Display/ConversationPage';
import ConversationsPage from 'containers/Conversation/Display/ConversationsPage';
import FlaggedConversations from 'containers/Conversation/FlaggedConversations';
import Courses from 'containers/Courses/Courses';
import StandardCourses from 'containers/Courses/StandardCourses';
import AllForms from 'containers/FormTemplate/Page/AllForms';
import SingleForm from 'containers/FormTemplate/Page/SingleForm';
import SingleFormTemplate from 'containers/FormTemplate/Page/SingleFormTemplatePage';
import IndexWrapper from 'containers/IndexWrapper';
import UserLogs from 'containers/Logs/UserLogs';
import ListPage from 'containers/Matrix/ListPage';
import TestPage from 'containers/Matrix/TestPage';
import Meeting from 'containers/Meeting/Display/Meeting';
import MeetingInstance from 'containers/Meeting/Display/MeetingInstance';
import MyMeetings from 'containers/Meeting/Display/MyMeetings';
import Notifications from 'containers/Notifications';
import ConditionReceiver from 'containers/ConditionReceiver';
import GroupsPage from 'containers/Groups/GroupsPage';
import Schedule from 'containers/Schedule/Schedule';
import AllPosts from 'containers/Posts/AllPosts';
import AdministrateAdjustments from 'containers/AdditionalAdjustments/Administration/AdministrateAdjustments';
import CourseProgress from 'containers/Progress/Course';
import UserProgress from 'containers/Progress/User';
import Guardian from 'containers/Guardian/Guardian';
import Search from 'containers/Search';
import SectionWrapper from 'containers/Section/SectionWrapper';
import SectionBaseGroupPage from 'containers/BaseGroups/Display/SectionBaseGroupPage';
import SinglePost from 'containers/SinglePages/SinglePost';
import SinglePreschoolDocument from 'containers/SinglePages/SinglePreschoolDocument';
import Staff from 'containers/User/Staff';
import Settings from 'containers/Settings';
import SubjectPage from 'containers/Verdict/Display/SubjectPage';
import CreateMeetingWizard from 'containers/Meeting/Form/CreateMeetingWizard';
import UserBookmarks from 'containers/Bookmarks/User';
import Admin from 'containers/Admin/Index';
import SingleAssignmentV1 from 'containers/SinglePages/SingleAssignmentV1';
import Tasks from 'containers/Tasks/Tasks';
import UserDocuments from 'components/List/UserDocuments';
import Plans from 'containers/Plans/Plans';
import SubmissionsView from 'containers/SinglePages/Assignment/SubmissionsView';
import PlanningWrapper from 'containers/SinglePages/Plan/PlanningWrapper';
import SectionProgress from 'containers/Progress/Section';
import SingleCourse from 'containers/SinglePages/SingleCourse';
import SingleLesson from 'containers/Lesson/Single';
import LanguageRender from 'components/LanguageRender/LanguageRender';
import SMSOverview from 'containers/SMS/Overview';
import SingleSMS from 'containers/SMS/Single';
import NewVerdictPage from './Verdict/Page/NewVerdict';
import 'assets/css/main.scss';

var App = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);

  var _super = _createSuper(App);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getData", function () {
      var user = getUser();
      var timer = setTimeout(function () {
        _this.setState({
          showSession: true
        });
      }, 1000 * 5);

      if (user == null) {
        onMsalTokenError(null, 'login_required');
        return false;
      }

      if (user != null) {
        _this.props.getTenant().then(function () {
          Promise.all([_this.props.setUser(user), _this.props.getMe(), _this.props.getTypes(getActiveLanguage())]).then(function () {
            var currentUser = _this.props.currentUser;

            if (appInsights != null) {
              appInsights.context.application.ver = packageJson.version;
              appInsights.setAuthenticatedUserContext(currentUser.logId, null, true);
              appInsights.trackTrace({
                message: 'User Logged in'
              });
            }

            if (currentUser.schools != null && currentUser.schools.length > 0) {
              schoolHandling.fetchSchool(_this.props.activeSchool, currentUser);
              roleHandling.fetchRole(_this.props.activeRole, currentUser);
            }

            if (_this.props.activeSchool != null) {
              _this.props.getSchoolServices(_this.props.activeSchool);
            }

            _this.setState({
              loading: false
            });

            clearTimeout(timer);

            _this.props.getEducationGroups().then(function () {
              if (_this.props.groups == null || _this.props.groups.length == 0) {
                trackNoGroups(currentUser.id);
              }
            });

            _this.props.getMenuItems();
          })["catch"](function (error) {
            _this.setState({
              loading: false,
              error: error
            });
          });
        });
      } else {
        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    _defineProperty(_assertThisInitialized(_this), "isDesktop", function () {
      if (sniffer.isTablet) {
        return true;
      }

      if (sniffer.isDesktop) {
        return true;
      }

      return false;
    });

    _this.state = {
      background: '#f5f5f5',
      loading: true,
      showSession: false,
      error: null
    };
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.getData();

      if (microsoftTeams.app.isInitialized()) {
        microsoftTeams.app.getContext().then(function (context) {
          if (context == null) {
            return false;
          }

          if (context.page.subPageId != null && context.page.subPageId != "") {
            var notificationId = _this2.getParameterByName('notificationId', context.page.subPageId);

            if (notificationId != null && notificationId != '') {
              _this2.props.markNotificationAsRead(notificationId);
            }

            _this2.props.history.push(context.page.subPageId);
          }
        });
        this.setState({
          background: '#f5f5f5'
        });
      }
    }
  }, {
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }), this.state.showSession ? /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'var(--color--meta)'
          }
        }, "Session ID: ", localStorage.getItem('hsid')) : null);
      }

      if (this.state.error != null) {
        var _this$state$error, _this$state$error2;

        if (((_this$state$error = this.state.error) === null || _this$state$error === void 0 ? void 0 : _this$state$error.data.errorCode) == 'invalid_grant' || ((_this$state$error2 = this.state.error) === null || _this$state$error2 === void 0 ? void 0 : _this$state$error2.data.errorCode) == 'interaction_required') {
          var _this$state$error3;

          return /*#__PURE__*/React.createElement(InteractionRequired, {
            error: (_this$state$error3 = this.state.error) === null || _this$state$error3 === void 0 ? void 0 : _this$state$error3.data
          });
        } else {
          return /*#__PURE__*/React.createElement(RequiredDataError, {
            error: this.state.error
          });
        }
      }

      if (this.props.currentUser != null) {
        if (!this.props.services.haldorEducation && !this.props.services.haldorCoursePlanning) {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "login-content"
          }, /*#__PURE__*/React.createElement("h1", null, this.props.translate('haldor-education-not-activated')), /*#__PURE__*/React.createElement("p", {
            className: "login-content__subtitle"
          }, this.props.translate('not-a-customer-2'))), /*#__PURE__*/React.createElement(Footer, null));
        }

        var currentUser = this.props.currentUser;

        if (currentUser.schools == null || currentUser.schools.length < 1 || currentUser.roles == null || currentUser.roles.length < 1) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              backgroundColor: this.state.background
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "login-content"
          }, /*#__PURE__*/React.createElement("h1", null, this.props.translate('something-went-wrong')), /*#__PURE__*/React.createElement("p", {
            className: "login-content__subtitle"
          }, this.props.translate('error-no-schools-or-roles'))), /*#__PURE__*/React.createElement(Footer, null));
        }

        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(NotificationProvider, null), /*#__PURE__*/React.createElement(Error, null), !this.isIframe() && this.isDesktop() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "desktop-header-spacing"
        }), /*#__PURE__*/React.createElement(DesktopHeader, null)) : null, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Sider, null, this.isDesktop() ? /*#__PURE__*/React.createElement(Menu, null) : null), /*#__PURE__*/React.createElement(Content, {
          style: {
            marginBottom: '4rem'
          }
        }, !this.isDesktop() ? /*#__PURE__*/React.createElement(DeviceHeader, null) : /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
          path: "/",
          exact: true,
          component: IndexWrapper
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/menu",
          component: MenuPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/administration",
          component: Admin
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/assignments",
          component: Tasks
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/posts",
          component: AllPosts
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/plans",
          component: Plans
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/overview/mentor",
          component: MentorGroups
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/schedule",
          component: Schedule
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/notifications",
          component: Notifications
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/assignment/:assignmentId/task/:taskId/documents",
          component: UserDocuments
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/assignment/:assignmentId/submission/:submissionId/documents",
          component: SubmissionsView
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/assignment/:assignmentId",
          component: SingleAssignmentV1
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/plan/:planId",
          component: PlanningWrapper
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/additionaladjustments",
          component: AdministrateAdjustments
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups",
          component: GroupsPage,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups/:groupId",
          component: SectionWrapper,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups/:groupId/progress/:userId",
          component: SectionProgress,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups/:groupId/course/:courseId",
          component: CourseProgress,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups/:groupId/course/:courseId/student/:userId",
          component: NewVerdictPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/groups/:groupId/basegroups",
          component: SectionBaseGroupPage,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/evaluations",
          component: SubjectPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/logs",
          component: UserLogs
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/search",
          component: Search,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/preschooldocument/:id",
          component: SinglePreschoolDocument
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/post/:id",
          component: SinglePost
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/editMatrix/:matrixId",
          component: TestPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/matrix",
          component: TestPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/matrixList",
          component: ListPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/courses",
          component: Courses,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/courses/standard",
          component: StandardCourses,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/course/:courseId",
          component: SingleCourse
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/lesson/:id",
          component: SingleLesson
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/report/absence",
          component: AbsenceOverview
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/report/attendance",
          component: AttendanceOverview
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/user/:userId/progress",
          component: UserProgress
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/progress",
          component: UserProgress
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/sms",
          exact: true,
          component: SMSOverview
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/sms/:id",
          component: SingleSMS
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/user/:userId",
          component: Staff
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/guardian/:userId",
          component: Guardian
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/guardian",
          component: Guardian
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/conversations",
          component: ConversationsPage,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/conversations/admin/flagged",
          component: FlaggedConversations
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/conversations/:id",
          component: ConversationPage
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/forms/templates",
          component: AllForms,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/form/:id",
          component: SingleForm
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/forms/template/:id",
          component: SingleFormTemplate
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/meetings/wizard",
          component: CreateMeetingWizard,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/meetings",
          component: MyMeetings,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/meeting/:id",
          component: Meeting,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/meeting/:id/instance/:instanceId",
          component: MeetingInstance,
          exact: true
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/settings",
          component: Settings
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/condition",
          component: ConditionReceiver
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/bookmarks",
          component: UserBookmarks
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/language",
          component: LanguageRender
        }), /*#__PURE__*/React.createElement(Route, {
          path: "/switch",
          component: SchoolSwitch
        })), /*#__PURE__*/React.createElement(Footer, null))));
      } else {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
    }
  }]);

  return App;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser,
    services: state.Services.availableServices,
    activeSchool: state.user.activeSchool,
    activeRole: state.user.activeRole,
    groups: state.sections.educationGroups
  };
}

export default withRouter(connect(mapStateToProps, {
  setUser: setUser,
  getEducationGroups: getEducationGroups,
  getTenant: getTenant,
  getSchoolServices: getSchoolServices,
  getMe: getMe,
  getSections: getSections,
  getMenuItems: getMenuItems,
  getTypes: getTypes,
  markNotificationAsRead: markNotificationAsRead
})(App));